export const StickyCTAs: React.FC = () => {
  return (
    <>
      {/* Mobile sticky bottom bar */}
      <div className="sticky-cta-mobile fixed bottom-0 inset-x-0 z-30 md:hidden">
        <div className="flex items-center justify-between px-4 py-3 bg-white border-t shadow-lg">
          <div className="text-xs">
            <p className="font-semibold text-slate-900">Ageiro ARK</p>
            <p className="text-slate-600">System of Intelligence for the Built World</p>
          </div>
          <a href="https://www.ageiro.global/contact-sales" className="primary-cta px-4 py-2 rounded-lg text-xs font-semibold shadow-sm">
            Request a Demo
          </a>
        </div>
      </div>
    </>
  );
};
